/**
 * Button component.
 */

import { ButtonHTMLAttributes, AnchorHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/utils/cn';
import './button.scss';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  as?: 'button' | 'a';
}

type ButtonOrAnchorProps = ButtonProps | (AnchorHTMLAttributes<HTMLAnchorElement> & { as: 'a' });

export const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonOrAnchorProps>(
  ({ className, variant = 'primary', size = 'md', as = 'button', ...props }, ref) => {
    const classes = cn(
      'button',
      {
        'button--primary': variant === 'primary',
        'button--secondary': variant === 'secondary',
        'button--danger': variant === 'danger',
        'button--ghost': variant === 'ghost',
        'button--sm': size === 'sm',
        'button--md': size === 'md',
        'button--lg': size === 'lg',
      },
      className
    );

    if (as === 'a') {
      return (
        <a
          ref={ref as React.ForwardedRef<HTMLAnchorElement>}
          className={classes}
          {...(props as AnchorHTMLAttributes<HTMLAnchorElement>)}
        />
      );
    }

    return (
      <button
        ref={ref as React.ForwardedRef<HTMLButtonElement>}
        className={classes}
        {...(props as ButtonHTMLAttributes<HTMLButtonElement>)}
      />
    );
  }
);

Button.displayName = 'Button';

